import { Injectable, Inject, Optional, OnInit } from '@angular/core';

import { QueryParams } from './grid-params';
import { GridSort } from './grid-sort.model';

@Injectable()
export class GridSortingService {

  public static SORTING_FIELDS: string = 'sortingFields';
  public currentSort: GridSort = new GridSort();

  constructor(
    private queryParams: QueryParams,
    @Inject(GridSortingService.SORTING_FIELDS)
    @Optional()
    private sortingFields: Array<string>
  ) {
    let currentSortingFields: Array<string> = [];
    let currentSortingOrder: string;

    for (let field of this.sortingFields) {
      let order: string = this.queryParams.getParam(this.fieldToParam(field));

      if (order === null) {
        continue;
      }

      currentSortingOrder = order;
      currentSortingFields.push(field);
    }

    let defaultSortingFields: Array<string> = currentSortingFields
      .filter((field: string) => this.queryParams.isDefaultParam(this.fieldToParam(field)));

    if (
      defaultSortingFields.length > 0 &&
      defaultSortingFields.length !== currentSortingFields.length
    ) {
      // unset default sorting params if sorting is defined in query

      for (let field of defaultSortingFields) {
        this.queryParams.unsetParam(this.fieldToParam(field), true);
      }

      currentSortingFields = currentSortingFields
        .filter((field: string) => defaultSortingFields.indexOf(field) === -1);
    }

    this.currentSort = new GridSort(
        currentSortingFields.join(','),
        currentSortingOrder
      );
  }

  public sortGrid(field: string, order: string) {
    if (!field) {
      return;
    }

    if (this.currentSort.field !== null) {
      this.unsetSorting(this.currentSort.field);
    }

    this.currentSort = new GridSort(field, order);
    this.setSorting(this.currentSort.field, this.currentSort.order);
  }

  private setSorting(fieldsName: string, order: string) {
    let fields: Array<string> = fieldsName.split(',');

    for (let field of fields) {
      this.queryParams.setParam(this.fieldToParam(field), order);
    }
  }

  private unsetSorting(fieldsName: string) {
    let fields: Array<string> = fieldsName.split(',');

    for (let field of fields) {
      this.queryParams.unsetParam(this.fieldToParam(field), true);
    }
  }

  private fieldToParam(name: string): string {
    return 'sorting[' + name + ']';
  }

}



// WEBPACK FOOTER //
// /dist/src/app/shared/grid/grid-sorting.service.ts